/**
 * 语音对话模式开关的本地持久化（T10）。
 *
 * 键固定为 `t10.voiceMode`；读取时做一次宽松解析（只有字符串 `"true"` 才算开启），
 * 存储不可用（无 localStorage / 隐私模式抛错）时静默降级，不阻塞 UI。
 */

import { VOICE_MODE_STORAGE_KEY } from './types';
import type { ReadableStorage } from './types';

function defaultStorage(): ReadableStorage | null {
  try {
    if (typeof globalThis.localStorage === 'undefined') return null;
    return globalThis.localStorage;
  } catch {
    return null;
  }
}

/** 读取开关状态；未写入过 / 数据损坏时回落 `false`。 */
export function readVoiceMode(storage?: ReadableStorage): boolean {
  const store = storage ?? defaultStorage();
  if (store === null) return false;
  try {
    return store.getItem(VOICE_MODE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

/** 写入开关状态；写入失败静默忽略（下次仍回落默认值）。 */
export function writeVoiceMode(enabled: boolean, storage?: ReadableStorage): void {
  const store = storage ?? defaultStorage();
  if (store === null) return;
  try {
    store.setItem(VOICE_MODE_STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    // 存储不可用时不影响当前会话内的开关状态
  }
}